'use client';

import { Radio, RadioList, Sticker, View } from '@bytel/trilogy-react-ts';

import { getAppConfig } from '@services/config';

import { Connectivity, JOURNEYS, PlanType } from '@app-types/product';

import { useHome } from '@landing/hooks';

export function DataList({
    plans,
}: Readonly<{
    plans: PlanType[];
}>) {
    const appConfig = getAppConfig();
    const {
        selectedPlan,
        selectedOption,
        setSelectedPlan,
        temporarilySelectedPlan,
        setSelectedNetwork,
        setTemporarilySelectedPlan,
        otisConfigurator,
    } = useHome();
    const isMobileFirst = otisConfigurator.value === JOURNEYS.BYOU;
    const baseProduct = isMobileFirst ? selectedPlan : temporarilySelectedPlan;

    const onChange = (plan: PlanType) => {
        if (plan.option5g && Object.values(plan.option5g).length === 0) {
            setSelectedNetwork(Connectivity.FIVE_G);
        } else if (!selectedOption) {
            setSelectedNetwork(Connectivity.FOUR_G);
        }
        if (isMobileFirst) {
            setSelectedPlan(plan);
        } else {
            setTemporarilySelectedPlan(plan);
        }
    };
    const sortedPlans = [...plans]?.sort((a, b) => a.dataSize - b.dataSize);

    return (
        <>
            <RadioList isMobile className='byou-radios offers'>
                {sortedPlans.map((plan) => {
                    const isSelected = baseProduct
                        ? plan.gencode === baseProduct?.gencode
                        : plans?.find((plan) => plan.highLight)?.gencode === plan.gencode;

                    const isSummerEdition = plan.gencode === appConfig.offers.summerEditionGencode;
                    return (
                        <View style={{ position: 'relative' }} key={plan.gencode}>
                            {isSummerEdition && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 1,
                                    }}
                                >
                                    <Sticker small className='byou-sticker'>
                                        Summer edition
                                    </Sticker>
                                </div>
                            )}
                            <Radio
                                onChange={() => onChange(plan)}
                                label={plan.dataEnvelope}
                                checked={isSelected}
                                horizontalTile
                                tile
                                value={plan.gencode}
                                id={plan.gencode}
                            />
                        </View>
                    );
                })}
            </RadioList>
        </>
    );
}
